export class MinPercentageError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MinPercentageError';
  }
}
